import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DoctrineApiService {

  constructor(
    private http: HttpClient,
  ) { }

  getBooks(filter: any): Observable<any> {
    return this.http.get(`${environment.URL_API_AV}/api/doctrine/web/public`, { params: filter });
  }

  getFile(payload: any): Promise<any> {
    return this.http.post(`${environment.URL_API_AV}/api/files/book/resources`, payload, { responseType: 'blob' }).toPromise();
  }

}
